// TenantErrorPage.tsx - Página de Error estilo ITOBOX
import React from 'react';
import { AlertCircle } from 'lucide-react';

interface TenantErrorPageProps {
  message?: string;
}

const TenantErrorPage: React.FC<TenantErrorPageProps> = ({ message }) => {
  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-icon">
          <AlertCircle size={64} />
        </div>
        <h1 className="error-title">Error de Tenant</h1>
        <p className="error-message">
          {message || 'No se pudo cargar la información del tenant. Por favor, verifica la URL e intenta nuevamente.'}
        </p>
        <button
          className="btn-retry"
          onClick={() => window.location.reload()}
        >
          Reintentar
        </button>
      </div>

      <style>{`
                .error-page {
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #FAFAFA;
                    padding: 24px;
                }

                .error-container {
                    max-width: 500px;
                    text-align: center;
                    background: white;
                    border: 1px solid #E0E0E0;
                    border-radius: 8px;
                    padding: 48px 32px;
                }

                .error-icon {
                    width: 96px;
                    height: 96px;
                    background: #FFEBEE;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 24px;
                    color: #D32F2F;
                }

                .error-title {
                    font-size: 24px;
                    font-weight: 600;
                    color: #212121;
                    margin: 0 0 12px 0;
                }

                .error-message {
                    font-size: 14px;
                    color: #757575;
                    margin: 0 0 32px 0;
                    line-height: 1.6;
                }

                .btn-retry {
                    padding: 12px 32px;
                    background: #2196F3;
                    color: white;
                    border: none;
                    border-radius: 4px;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                }

                .btn-retry:hover {
                    background: #1976D2;
                }
            `}</style>
    </div>
  );
};

export default TenantErrorPage;
